import { useQuery } from "@jti/rest-api";

import { magento } from "../../clients/getClient";

export const useProductImage = (sku: string | undefined = "") =>
  useQuery(["GET_PRODUCT_IMAGE_FROM_MAGENTO", sku], () => magento.getProductImage(sku), {
    enabled: !!sku,
  });
